/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceFeeType } from './ServiceFeeType';
import {
    ServiceFeeTypeFromJSON,
    ServiceFeeTypeFromJSONTyped,
    ServiceFeeTypeToJSON,
    ServiceFeeTypeToJSONTyped,
} from './ServiceFeeType';

/**
 * 
 * @export
 * @interface MenuOrderServiceFee
 */
export interface MenuOrderServiceFee {
    /**
     * 
     * @type {ServiceFeeType}
     * @memberof MenuOrderServiceFee
     */
    type: ServiceFeeType;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderServiceFee
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderServiceFee
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderServiceFee
     */
    amount: number;
}



/**
 * Check if a given object implements the MenuOrderServiceFee interface.
 */
export function instanceOfMenuOrderServiceFee(value: object): value is MenuOrderServiceFee {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function MenuOrderServiceFeeFromJSON(json: any): MenuOrderServiceFee {
    return MenuOrderServiceFeeFromJSONTyped(json, false);
}

export function MenuOrderServiceFeeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuOrderServiceFee {
    if (json == null) {
        return json;
    }
    return {
        
        'type': ServiceFeeTypeFromJSON(json['type']),
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'amount': json['amount'],
    };
}

export function MenuOrderServiceFeeToJSON(json: any): MenuOrderServiceFee {
    return MenuOrderServiceFeeToJSONTyped(json, false);
}

export function MenuOrderServiceFeeToJSONTyped(value?: MenuOrderServiceFee | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': ServiceFeeTypeToJSON(value['type']),
        'name': value['name'],
        'description': value['description'],
        'amount': value['amount'],
    };
}

